import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminAgentContent } from '@apps/web/routes/_app/admin/agent/admin_agent_content';

const runSearchSchema = z.object({
    // Optional deep-link target — the scratchpad evidence-ref surface routes
    // through this so a note's artifact evidence lands on the artifact itself
    // instead of the generic run overview.
    artifact: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/admin/agent/$runId')({
    component: AdminAgentRunPage,
    validateSearch: runSearchSchema,
});

function AdminAgentRunPage() {
    const { runId } = Route.useParams();
    const { artifact } = Route.useSearch();
    return (
        <AdminAgentContent
            initialRunId={runId}
            initialArtifactId={artifact ?? null}
        />
    );
}
